module.exports = "<app-widgets-summary object=$ctrl.area type=area></app-widgets-summary> <app-widgets-review-info-view object=$ctrl.area></app-widgets-review-info-view> <app-widgets-transitions object=$ctrl.area kind=\"'protection_area'\" object-versions=$ctrl.areaVersions></app-widgets-transitions> <br> <ui-view></ui-view> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/area/view/component_partial.html
// module id = 408
// module chunks = 0